import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import styled from "styled-components"; //eslint-disable-line
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnDark";
import MainFeature1 from "components/features/TwoColWithButton.js";
// import MainFeature2 from "components/features/TwoColSingleFeatureWithStats.js";
// import MainFeature3 from "components/features/TwoColSingleFeatureWithStats2.js";
import Features from "components/features/ThreeColSimple.js";
// import Features from "components/features/ThreeColWithSideImage.js";
import TeamCardGrid from "components/cards/ProfileThreeColGrid.js";

import SupportIconImage from "images/support-icon.svg";
import ShieldIconImage from "images/shield-icon.svg";
import CustomerLoveIconImage from "images/simple-icon.svg";
import DashedBorderSixFeatures from "components/features/DashedBorderSixFeatures";
import TwoColSingleFeatureWithStats from "components/features/TwoColSingleFeatureWithStats";
import TwoColumnWithVideo from "components/hero/TwoColumnWithVideo";
import OilGas from "../../images/oilgas.png"
import OilGas2 from "../../images/oilgas2.jpg"
import ContactUs from "pages/ContactUs";
import TwoColContactUsWithIllustrationFullForm from "components/forms/TwoColContactUsWithIllustrationFullForm";
import GetStarted from "components/cta/GetStarted";
import SEO from "components/SEO";

const Subheading = tw.span`uppercase tracking-wider text-sm`;
export default ({ roundedHeaderButton }) => {
  return (
    <AnimationRevealPage>
         <SEO
title="Oil & Gas Page" 
description="Oil & Gas Page"
/>
      <TwoColumnWithVideo
       heading="Delivering Integrated Mobile Solutions and Tech-Driven Services for the Oil & Gas Industry."
       buttonRounded={false}
       primaryButtonText="Request free consultation"
       primaryButtonUrl = "https://calendly.com/solutions-tbnw/30min?month=2024-11"
       description="Metromidas provides end-to-end custom IT engineering services for the oil and gas industry, optimizing production, distribution, and trading. Our solutions focus on operational excellence, supply chain efficiency, capital project execution, and improved exploration, helping businesses achieve better ROI and deliver superior customer service."
       imageSrc={OilGas}
       />

<MainFeature1
        subheading={<Subheading></Subheading>}
        heading="Oil and Gas Enterprise Mobility Solution"
        buttonRounded={false}
        primaryButtonText="Contact Us"
        primaryButtonUrl = "/contactus"
        description="Reshape your energy landscape and gain better control by harnessing the best technology solutions into production, sales, distribution and trading operations.

"
        imageSrc={OilGas2}
        textOnLeft={false}
      />
       <GetStarted />

<TwoColContactUsWithIllustrationFullForm />
      <Footer />
    </AnimationRevealPage>
    
  );
};
